<template>
  <v-container>
    <v-flex md8 offset-md2>
      <v-card>
        <!-- errors -->
        <div v-if="errorMessage" class="red--text no-print" >
          <strong>{{errorMessage}}</strong>
        </div>
        <div >
          <v-layout pt-2 pr-3 class="no-print">
            <v-spacer></v-spacer>
            <v-btn
              v-if="userRole == rootRoleName"
              class="primary lighten-1 white--text"
              @click="createDownloadZip">
              <v-icon>cloud_download</v-icon>
              {{$t('aplix-use-only.usage-report.button-csv-download')}}
            </v-btn>
            <div>
              <v-btn
                :disabled="isIOS()"
                outline
                class="grey grey--text text--darken-3"
                @click="printDiv()">
                <v-icon>print</v-icon>
                {{$t('usage-report.print')}}
              </v-btn>
              <div v-if="isIOS()">
                {{$t('usage-report.can-not-print-ios')}}
              </div>
            </div>
          </v-layout>
          <v-layout pt-2 pr-3 class="no-print" justify-end>
            <v-flex xs3 class="where-select-box">
              <v-select
                :items="dateList"
                item-text="label"
                item-value="value"
                :label="$t('usage-report.date')"
                v-model="selectedDate"
                :disabled="!dispFlag"
              ></v-select>
            </v-flex>
            <v-flex 
             v-if="userRole == rootRoleName"
             xs3
             class="where-select-box"
            >
            <v-select　
              :items="summariesPcList"
              item-text="organizationName"
              item-value="organizationId"
              :label="$t('aplix-use-only.usage-report.pc-organization')"
              v-model="selectPcOrg"
              :rules="[v => !!v || $t('validate.select')]"
              :error="summariesPcListError"
            ></v-select>
            </v-flex>
          </v-layout>
        </div>
        <v-container id="usage-report">
          <v-flex md10 offset-md1>
            <v-card-title pa-0>
              <v-flex md7>
                <h4>{{$t('usage-report.organization-name')}}</h4>
                <h1>{{ usageSummaries.organizationName }}</h1>
              </v-flex>
              <v-flex md3 offset-md2 align-self-center="true">
                <h4>{{ $t('usage-report.date')}}</h4>
                <h2>{{dispDate }}</h2>
              </v-flex>
            </v-card-title>
            <v-card-title>
              <v-flex md7 offset-md1>
                <h2>{{$t('usage-report.total-device-count')}}</h2>
              </v-flex>
              <v-flex md2 offset-md2>
                <h2>{{ usageSummaries.totalCount }}{{$t('usage-report.units')}}</h2>
              </v-flex>
            </v-card-title>
            <v-card-title>
              <h4>{{$t('usage-report.location-count-title')}}</h4>
            </v-card-title>
            <v-card-actions>
              <v-data-table
                :headers="locationListHeaders"
                :items="locationListTable"
                class="usage-report-table"
                :no-data-text="$t('usage-report.no-data-text')"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ props.item.organizationName }}</td>
                  <td class="text-xs-left">{{ props.item.locationName }}</td>
                  <td class="text-xs-right">{{ props.item.deviceCount }}</td>
                </template>
              </v-data-table>
            </v-card-actions>
            <v-card-title>
              <h4>{{$t('usage-report.device-count-title')}}</h4>
            </v-card-title>
            <v-card-actions>
              <v-data-table
                :headers="deviceListHeaders"
                :items="deviceListTable"
                class="usage-report-table"
                :no-data-text="$t('usage-report.no-data-text')"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ props.item.organizationName }}</td>
                  <td class="text-xs-left">{{ props.item.locationName }}</td>
                  <td class="text-xs-left">{{ props.item.filtrationSystemName }}</td>
                  <td class="text-xs-left">{{ props.item.uniqueId }}</td>
                </template>
              </v-data-table>
            </v-card-actions>
          </v-flex>
        </v-container>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import http from '@/utils/http.js'
import utils from '@/utils/utils.js'
import config from '@/config.js'
import axios from 'axios'

export default {
  components: {

  },
  data () {
    return {
      locale: this.$store.getters.locale,
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: config.role.Root,
      pcRoleName: config.role.Root,
      dispFlag: false,
      usageSummaries: {
        organizationName: '',
        totalCount: ''
      },
      dateList: [],
      selectedDate: '',
      dispDate: '',
      summariesPcListError: false,
      summariesPcList: [],
      locationListHeaders: [
        {text: this.$t('usage-report.location-count-list.organization-name'), value: 'organizationName'},
        {text: this.$t('usage-report.location-count-list.location-name'), value: 'locationName'},
        {text: this.$t('usage-report.location-count-list.device-count'), value: 'deviceCount'}
      ],
      locationListTable: [],
      deviceListHeaders: [
        {text: this.$t('usage-report.device-count-list.organization-name'), value: 'organizationName'},
        {text: this.$t('usage-report.device-count-list.location-name'), value: 'locationName'},
        {text: this.$t('usage-report.device-count-list.filtration-system-name'), value: 'filtrationSystemName'},
        {text: this.$t('usage-report.device-count-list.unique-id'), value: 'uniqueId'}
      ],
      deviceListTable: [],
      errorMessage: '',
      selectPcOrg: ''
    }
  },
  methods: {
    init () {
      this.getDateLists()
    },
    /**
     * Summaryのリストの年月リスト
     */
    getDateLists () {
      this.dateList = []
      // リストデータの取得
      http.request('get', '/service2/dashboard/api/summaries/getDateList')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get summaries date list data failed. (' + data.result + ')')
            return
          }
          // console.log(data)
          this.dispFlag = data.DispFlag
          // 表示用の配列に格納
          let dateLists = data.DateLists
          // リストが取れない場合は
          if (!dateLists) {
            // データを取得できなかった旨を表示
            this.showError(this.$t('usage-report.failed-display-no-data'))
            this.dispFlag = false
          }
          let setDate = ''
          for (let key in dateLists) {
            let row = {
              label: key,
              value: dateLists[key]
            }
            this.dateList.push(row)
            setDate = dateLists[key]
          }
          // 初期表示月は最新月とする
          this.selectedDate = setDate
        })
        .catch(() => {
          // TODO エラー処理
          // console.log('error', error)
        })
    },
    /**
     * 対象年月のSummaryのリスト取得
     */
    getSummariesLists () {
      // 共通変数の初期化
      this.dispDate = ''
      this.locationListTable = []
      this.deviceListTable = []
      this.errorMessage = ''
      this.usageSummaries.organizationName = ''
      this.usageSummaries.totalCount = ''
      // Rootかつ組織が選択されない場合は実行しない
      if (utils.isRoot(this.$store.getters.user.roles) && !this.selectPcOrg) {
        return
      }
      // パラメータを生成
      const params = {
        date: this.selectedDate,
        organizationId: this.selectPcOrg
      }
      // thisをselfに格納
      const self = this
      // リストデータの取得
      http.request('post', '/service2/dashboard/api/summaries/getSummary', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get usage summaries data failed. (' + data.result + ')')
            // データを取得できなかった旨を表示
            this.showError(this.$t('usage-report.failed-display-no-data'))
            return
          }
          // 日付をバインド
          this.getDispDate()
          self.usageSummaries.organizationName = data.organizationName
          self.usageSummaries.totalCount = data.devices.length
          // 設置拠点内訳
          if (data.locations.length > 0) {
            // 表示用の配列に格納
            let locations = data.locations
            for (let i in locations) {
              let row = {
                organizationName: locations[i].organizationName,
                locationName: locations[i].locationName,
                deviceCount: locations[i].deviceCount
              }
              self.locationListTable.push(row)
            }
          }
          // 個別内訳
          if (data.devices.length > 0) {
            // 表示用の配列に格納
            let devices = data.devices
            for (let i in devices) {
              let row = {
                organizationName: devices[i].organizationName,
                locationName: devices[i].locationName,
                filtrationSystemName: devices[i].filtrationSystemName,
                uniqueId: devices[i].jm1UniqueId
              }
              self.deviceListTable.push(row)
            }
          }
        })
        .catch(() => {
          // TODO エラー処理
          // console.log('error', error)
        })
    },
    /**
     * 印刷
     */
    printDiv () {
      window.print()
    },
    /**
     * ZIPファイル(中にCSVファイルが入っている)を作成し、作成に成功したらダウンロード処理を実行する
     * データがなくZIPファイルが作成されなかった場合はエラーメッセージを表示する
     */
    createDownloadZip () {
      self.errorMessage = ''
      http.request('get', '/service2/dashboard/api/summaries/getCsvDownloadUrl/' + this.selectedDate)
        .then(response => {
          const data = response.data
          // console.log(data)
          if (data.result === -500) {
            this.showError(this.$t('usage-report.failed-create-zip-file-fatal'))
          } else if (data.result === -501) {
            this.showError(this.$t('usage-report.failed-create-zip-file-busy'))
          } else if (data.downloadUrl !== undefined) {
            // csvダウンロードのファイル名は、YYYYMM以外は固定
            let downloadFileName = 'Summary' + this.selectedDate + '01000000.zip'
            this.downloadRequest(data.downloadUrl, downloadFileName)
          } else {
            this.showError(this.$t('usage-report.failed-download-no-data'))
          }
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
          this.showError(this.$t('usage-report.failed-create-zip-file-fatal'))
        })
      return
    },
    /**
     * ZIPダウンロードリクエストを発行する
     */
    async downloadRequest (downloadShortUrl, downloadFileName) {
      const downloadUrl = downloadShortUrl
      if (utils.iOS() && utils.safari()) {
        // #23338
        this.letBrowserToSave(null, downloadUrl, downloadFileName)
      } else {
        window._httpGrovalHookEnabled = false
        const getConfig = {
          responseType: 'blob'
        }
        const zipRes = await axios.get(downloadUrl, getConfig)
        let blob = new Blob([zipRes.data])
        this.letBrowserToSave(blob, null, downloadFileName)
      }
    },
    /**
     * blobファイルを保存する
     * iOS safariについては、ダウンロードリンクをクリックさせる
     * @param remoteTargetUrl
     *  null でない場合は brob を使わず、ブラウザにリモートからダウンロードさせる。
     *  IE11 は未実装。
     */
    letBrowserToSave (blob, remoteTargetUrl, downloadFileName) {
      // IE11はwindow.navigator.msSaveOrOpenBlobを利用してBlobをダウンロードさせる
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, downloadFileName)
      } else {
        const link = document.createElement('a')
        if (remoteTargetUrl) {
          console.log('let browser download ' + downloadFileName)
          link.href = remoteTargetUrl
        } else {
          link.href = window.URL.createObjectURL(blob)
          link.setAttribute('download', downloadFileName)
        }
        document.body.appendChild(link)
        console.log('link.click()')
        link.click()
      }
    },
    showError (error) {
      this.errorMessage = error
    },
    // iOSかどうか vueの中で直接使うために関数化
    isIOS () {
      return utils.iOS()
    },
    getDispDate () {
      // Keyを表示してるようなので取得
      this.dateList.forEach(function (element) {
        if (element.value === this.selectedDate) {
          this.dispDate = element.label
        }
      }, this)
    },
    getSummariesPCOrgList () {
      if (!utils.isRoot(this.$store.getters.user.roles)) {
        // Root以外では実行しない
        return
      }
      const self = this
      // リストデータの取得
      http.request('get', '/service2/dashboard/api/summaries/getSummariesPcList')
        .then(response => {
          const data = response.data
          console.log('data', data)
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get summariesPcList data failed. (' + data.result + ')')
            return
          }
          self.summariesPcList = data.summariesPcList
          console.log('summariesPcList', self.summariesPcList)
        })
        .catch(() => {
          // TODO エラー処理
          // console.log('error', error)
        })
    },
    // 選択されていない時に入力を促すためにエラー状態をコントロールする
    // 初期状態だとエラーにならないため
    summariesPcListErrorCntroll () {
      if (!utils.isRoot(this.$store.getters.user.roles)) {
        // Root以外では実行しない
        return
      }
      if (this.selectedDate && !this.selectPcOrg) {
        // 日付が選択されている場合は入力を促す
        this.summariesPcListError = true
      } else {
        this.summariesPcListError = false
      }
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    selectedDate () {
      this.getSummariesLists()
      // 以下Rootのみ機能
      this.getSummariesPCOrgList()
      this.summariesPcListErrorCntroll()
    },
    selectPcOrg () {
      // 以下Rootのみ機能
      this.summariesPcListErrorCntroll()
      this.getSummariesLists()
    }
  }
}
</script>

<style>
.usage-report-table {
  width: 100%;
  border-collapse: collapse;
}
.usage-report-table th{
  text-align: left;
}
.usage-report-table  .td-service{
    border-bottom: solid 1px #AAA !important;
}
.usage-report-table  th{
    border-bottom: solid 3px #AAA !important;
    border-top: solid 1px #AAA !important;
}
.usage-report-table .td-sum{
    text-align: right;
}
.usage-report-table tbody td{
    height: 24px !important;
}
.where-select-box{
    margin: 10px;
}


/* プリント用 */
@media print {
   main{padding:0 !important;}
   .top-nav{display:none;}
   .no-print{display:none;}
}

</style>



// WEBPACK FOOTER //
// UsageReport.vue?441ecf10